// extracted by mini-css-extract-plugin
export default {"splitContainerComponent":"ShopData_splitContainerComponent__imvzH"};